var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAvatarAW(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 94.87 94.87",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#007fc0;}.cls-2{fill:#f2e6d3;}.cls-3{fill:#e5d1ba;}.cls-4{fill:#dbbfa1;}.cls-5{fill:#0f272d;}.cls-6{fill:#162d35;}.cls-7{fill:#1c333d;}.cls-8{fill:#cb4e44;}.cls-9{fill:#e2574c;}.cls-10{fill:#e5766d;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2",
    "data-name": "Ebene 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "background"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 47.43,
    cy: 47.43,
    r: 47.43
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "45.38 59.26 34.36 53.67 30.69 35.35 31.65 18.7 40.22 12.41 58.06 12.41 66.41 18.13 67.4 35.42 61.23 52.81 52.73 59.26 45.38 59.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "67.4 35.42 63.24 18.99 57.59 20.12 60.04 31.74 49.03 37.25 49.03 48.13 59.93 52.32 45.38 59.26 52.73 59.26 63.73 53.77 67.4 35.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "67.4 35.42 66.41 18.11 63.24 18.99 67.4 35.42 59.93 52.32 63.75 53.77 67.4 35.42 67.4 35.42 67.4 35.42"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M60.2,93.11l-.07-5.49,3-3-.87-17-5.9-2.92H49.13v30.1A47.53,47.53,0,0,0,60.2,93.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M38.3,94V87.55l-2.91-2.93.74-13.68-3.82,9.79L34,92.91C35.42,93.32,36.84,93.67,38.3,94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M60,93.18c1.42-.38,2.8-.84,4.16-1.35l3.32-21.71L62,67.51l.83,17.2L60,87.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M36.16,70.88,35.1,84.66l2.83,2.91v6.32a47.63,47.63,0,0,0,22.27-.78l-.07-5.49,3-3-.87-17-5.9-2.92H41.71l-11,5.35,1.62,10.67Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "30.69 35.38 34.36 53.63 45.38 59.27 47.47 59.27 47.47 63.69 22.69 56.85 27.34 18.73 39.86 6.19 55.28 6.64 68.3 12.88 75.5 56.85 50.55 63.69 50.55 59.27 52.73 59.27 63.73 53.77 67.4 35.41 66.92 28.75 64.52 25.07 49.62 26.66 35.29 21.56 30.69 35.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "30.69 35.38 34.36 53.61 22.67 56.85 27.33 18.73 39.86 6.19 55.28 6.64 68.3 12.88 75.49 56.85 63.73 53.75 67.4 35.41 66.92 28.75 68.3 12.88 64.52 25.07 49.62 26.66 35.3 34.99 35.29 21.56 30.69 35.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "27.33 18.73 39.86 6.19 49.62 26.66 27.33 18.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "34.36 53.61 22.67 56.85 27.33 18.73 34.36 53.61"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 47.43,
    y: 59.22,
    width: 3.18,
    height: 5.56
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "50.61 64.78 47.43 60 50.61 60 50.61 64.78"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 47.43,
    y: 59.22,
    width: 3.18,
    height: 0.79
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M58.29,93.59l-9.16-8.48v9.7A47.55,47.55,0,0,0,58.29,93.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M60.2,93.11l-.07-5.49,3-3-.87-17-5.9-2.92-2.28,5-5,1.91V85.11l9.16,8.48C58.93,93.44,59.57,93.28,60.2,93.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M37.93,93.89a48,48,0,0,0,9.5,1c.57,0,1.14,0,1.7,0V71.65L44,69.74l-2.33-5-5.24,2.53L35.1,84.66l2.83,2.91Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarAW);
export default __webpack_public_path__ + "static/media/avatar-a-w.e21cd55d496379ec36f6019a86892e7b.svg";
export { ForwardRef as ReactComponent };